import cx from 'classnames'

import { uid } from '../../igao/utils'
import { PlainButton } from '../../shared/Button'
import { Divider } from '../../shared/Divider'
import { Button, Checkbox } from '../../shared/NarusMaterial'
import { onTemplateChange } from '../controller'
import indexStyles from '../index.module.scss'

import Igao from './igao'
import styles from './tables.module.scss'

const QuestionnaireTable = ({
  setTab,
  newItem,
  saveNewItem,
  setNewItem,
  data,
  page,
  handleOnKeyDown,
  setModal
}) => {
  const handleChange = (key, value) => setNewItem({
    ...newItem,
    [key]: value
  })
  let disableButton
  if (newItem.igao) {
    disableButton =
      (newItem.template?.length ?? 0) <= 0 ||
      (newItem.goal?.length ?? 0) <= 0 ||
      (newItem.label?.length ?? 0) <= 0 ||
      (newItem.unfavorable?.length ?? 0) <= 0 ||
      !Object.prototype.hasOwnProperty.call(newItem, 'page') ||
      !newItem.domain
  }
  if (!newItem.igao) {
    disableButton = newItem?.label?.trim().length <= 0
  }

  const onCancel = () => {
    if (Object.keys(newItem).length === 3) {
      return setTab(null)
    }
    return setModal({
      title:
        'It looks like you have been editing something. If you leave before saving, your changes will be lost.',
      open: true,
      actions: [
        <Button
          key={1}
          label='Cancel'
          onClick={() => {
            setModal(null)
          }}
          grey
        />,
        <Button
          key={2}
          label='Discard'
          onClick={() => {
            setNewItem({
              id: uid(),
              page,
              igao: true
            })
            setTab(null)
            setModal(null)
          }}
        />
      ]
    })
  }

  return (
    <div className={styles.addQuestionContainer}>
      <div>
        <div
          style={{
            margin: '0 30px 0px',
            padding: '30px 0px'
          }}
        >
          <label htmlFor='question'>Question</label>
          <input
            onChange={e => handleChange('label', e.target.value)}
            value={newItem.label || ''}
            className={cx(indexStyles.input, indexStyles.action)}
            name='question'
            placeholder='New Question'
          />
          <div style={{ marginTop: '20px' }}>
            <Checkbox
              value={!newItem?.igao}
              label='Does not trigger IGAO'
              onChange={() => {
                handleChange('igao', !newItem?.igao)
              }}
            />
          </div>
        </div>
        {newItem.igao && (
          <>
            <Divider />
            <Igao
              page={page}
              data={data}
              handleOnKeyDown={handleOnKeyDown}
              setNewItem={setNewItem}
              newItem={newItem}
              handleChange={handleChange}
            />
          </>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            margin: '-10px 30px 30px 30px',
            paddingBottom: '20px'
          }}
        >
          <PlainButton
            label='Cancel'
            onClick={() => onCancel()}
          />
          <PlainButton
            disabled={disableButton}
            label='Save'
            style={{ marginLeft: '12px' }}
            btnType='contained'
            color='primary'
            onClick={() =>
              saveNewItem(onTemplateChange(null, null, newItem, data[page].lists))
            }
          />
        </div>
      </div>
    </div>
  )
}

export default QuestionnaireTable
